import AddProfileForm from './AddProfileForm.container';

export default AddProfileForm;
